import e from"react";import{CMSImageMapPreview as t}from"../../CMSImageMapPreview/CMSImageMapPreview.js";const r=r=>{const{contentGroup:n}=r;return n?e.createElement(t,{contentGroup:n}):e.createElement(e.Fragment,null)};export{r as ImageMapSnippet};
//# sourceMappingURL=ImageMapSnippet.js.map
